// useUserAgent.ts
import { useState, useEffect } from 'react'

interface UserAgentInfo {
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
  isIOS: boolean
  isAndroid: boolean
  userAgent: string
}

export function useUserAgent(): UserAgentInfo {
  const [info, setInfo] = useState<UserAgentInfo>(() => {
    if (typeof window === 'undefined') {
      return {
        isMobile: false,
        isTablet: false,
        isDesktop: true,
        isIOS: false,
        isAndroid: false,
        userAgent: '',
      }
    }

    const ua = navigator.userAgent

    const isAndroid = /Android/i.test(ua)
    const isIOS = /iPhone|iPad|iPod/i.test(ua)
    const isTablet = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)
    const isMobile =
      /Mobile|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua) &&
      !isTablet

    return {
      isMobile,
      isTablet,
      isDesktop: !isMobile && !isTablet,
      isIOS,
      isAndroid,
      userAgent: ua,
    }
  })

  useEffect(() => {
    // Handle if userAgent changes (rare, but possible with some dev tools)
    const ua = navigator.userAgent

    const isAndroid = /Android/i.test(ua)
    const isIOS = /iPhone|iPad|iPod/i.test(ua)
    const isTablet = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)
    const isMobile =
      /Mobile|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua) &&
      !isTablet

    setInfo({
      isMobile,
      isTablet,
      isDesktop: !isMobile && !isTablet,
      isIOS,
      isAndroid,
      userAgent: ua,
    })
  }, [])

  return info
}
